import iApi from './iApi'
import mApi from './mApi'
import wApi from './wApi'
import uApi from './uApi'
const api = Object.assign(iApi,mApi,wApi,uApi);
export default api



// WEBPACK FOOTER //
// ./src/utils/api/index.js